import { useEffect, useState } from 'react'
import { Link, useNavigate, useParams } from 'react-router-dom'
import api from "../../../services/api";
import {IEventDate} from "../../../interfaces/IEventDate";
import {IEventEntry} from "../../../interfaces/IEventEntry";

export default function EventEntryList() {
  const { id } = useParams()
  const [eventEntries, setEventEntries] = useState<IEventEntry[]>([])
  const navigate = useNavigate()


  useEffect(() => {
    api.get('/api/event_entries/date/' + id)
      .then(resposta => {
          setEventEntries(resposta.data)
      })
  }, [])

  return (
    <>
      <div className='row'>
        <div className='col-md-12'>
          <h3 className='mb-2'>
            <b>Turmas</b>
          </h3>
        </div>
      </div>

      <div className='row my-4'>
        {eventEntries.map(eventEntry =>
          <div key={eventEntry.id} className='col-md-4 mt-3'>
            <div className='card'>
              <div className='card-body'>
                <h2><b>{eventEntry.title}</b></h2>
                <Link to={'/event-results/' + eventEntry.id} className='btn btn-block btn-primary'>Acessar</Link>
              </div>
            </div>
          </div>
        )}

      </div>
      <div className='row'>
          <div className='col-md-12 text-right'>
              <button className="btn btn-danger btn-floating" onClick={() => navigate(-1)}>Voltar<br/></button>
          </div>
      </div>
    </>
  )
}
